<template>
  <section class="Login">
    <transition name="fade">
      <div v-if="loading" class="Login__loading">
        <template v-if="!$auth.error">
          <Loader />
          <p>Please wait…</p>
        </template>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="!loading">
        <form class="Login__container" @submit.prevent="submit">
          <div class="Login__logo">
            <svg class="Login__logo--delegate" xmlns="http://www.w3.org/2000/svg" width="353" height="59" viewBox="0 0 353 59"><g fill="none" fill-rule="evenodd"><path fill="#61BDBB" d="M30.86 46.777l-.002.002-.003-.003L4.297 25.079 30.855 3.382l.001-.001.004.003 26.557 21.697.001.001-6.799 5.554-.003.003 2.069 1.69.004-.003 8.871-7.247L30.858-.003.156 25.079l.001.001-.001.002 30.702 25.08 3.822-3.122-2.072-1.69z"></path><path fill="#61BDBB" d="M66.23-.003l-3.821 3.122h.001l.004.004L64.48 4.81l1.747-1.427.001-.001.004.003 26.557 21.696-26.557 21.696-.002.002-.003-.002L39.669 25.08l6.8-5.556.003-.002-2.069-1.691-.002-.001-.003.003-8.87 7.247.001.001-.001.001 30.702 25.08L96.932 25.08z"></path><path fill="#61BDBB" d="M46.151 46.781l-1.753-1.432-1.747 1.428-.003.002-.003-.003-26.557-21.697 18.59-15.188.003-.002-2.07-1.691v-.001l-.003.003-20.661 16.879v.002l30.701 25.081 3.823-3.123-.318-.26zM38.833 3.122l2.066 1.687 1.747-1.427.001-.001.004.003L69.208 25.08l.001.001-12.694 10.371-.003.003 2.069 1.69.003-.002 14.767-12.064L42.649-.004l-3.821 3.122.001.001z"></path><path fill="#61BDBB" d="M50.623 3.122l2.066 1.687 1.747-1.427.001-.001.004.003L80.998 25.08l.001.001L62.41 40.268l-.004.003.001.001 2.069 1.69.003-.003 20.662-16.88L54.439-.004l-3.821 3.122.001.001zm3.818 43.655l-.002.002-.003-.003-26.558-21.697 12.695-10.371.003-.003-2.069-1.69-.002-.001-.002.002-14.766 12.063.001.001-.001.002 30.702 25.08 3.822-3.122-2.072-1.69z"></path><path d="M248.06 39.359c5.084 0 8.999-3.798 8.999-8.881 0-5.025-3.915-8.882-8.998-8.882-4.966 0-8.706 3.857-8.706 8.882 0 5.083 3.74 8.88 8.706 8.88zm-.934-24.131c4.967 0 8.414 2.162 9.407 4.907V15.87h7.012v24.54c0 6.195-.643 11.103-4.966 14.492-2.63 2.045-6.37 3.272-10.401 3.272-5.492 0-10.226-1.402-14.257-4.266l3.388-5.2c2.98 1.987 6.136 3.213 10.109 3.213 2.57 0 4.908-.583 6.486-1.752 2.454-1.811 2.805-4.85 2.805-7.48v-1.46c-1.286 2.337-4.674 4.324-9.583 4.324-8.297 0-14.724-6.486-14.724-15.075 0-8.59 6.427-15.25 14.724-15.25zM128.19 38.717c10.693 0 14.549-5.902 14.549-13.673 0-7.946-3.856-13.848-14.607-13.848h-6.72v27.52h6.778zM114.11 4.593h14.549c13.789 0 21.385 8.53 21.385 20.45 0 11.979-7.538 20.276-21.327 20.276H114.11V4.593zm55.09 16.419c4.091 0 7.421 2.922 7.421 6.427h-15.718c.292-3.564 3.915-6.427 8.297-6.427zm7.983 16.01c-2.094 1.985-4.209 3.039-7.574 3.039-5.2 0-8.648-3.04-8.88-7.713h22.903c.117-1.17.117-2.454.117-2.454 0-8.24-5.784-14.842-14.549-14.842-8.823 0-15.425 6.077-15.425 15.543v.233c0 9.233 6.368 15.192 15.6 15.192 4.441 0 8.59-1.227 12.387-5.258l-4.579-3.74zm38.016-16.01c4.09 0 7.421 2.922 7.421 6.427h-15.718c.292-3.564 3.915-6.427 8.297-6.427zm7.983 16.01c-2.094 1.985-4.209 3.039-7.574 3.039-5.2 0-8.648-3.04-8.88-7.713h22.903c.117-1.17.117-2.454.117-2.454 0-8.24-5.784-14.842-14.549-14.842-8.823 0-15.425 6.077-15.425 15.543v.233c0 9.233 6.368 15.192 15.6 15.192 4.441 0 8.59-1.227 12.387-5.258l-4.579-3.74zm114.396-16.01c4.09 0 7.42 2.922 7.42 6.427h-15.717c.292-3.564 3.915-6.427 8.297-6.427zm7.983 16.01c-2.094 1.985-4.21 3.039-7.574 3.039-5.2 0-8.648-3.04-8.881-7.713h22.904c.117-1.17.117-2.454.117-2.454 0-8.24-5.784-14.842-14.55-14.842-8.822 0-15.424 6.077-15.424 15.543v.233c0 9.233 6.368 15.192 15.6 15.192 4.44 0 8.589-1.227 12.387-5.258l-4.58-3.74zm-157.427 8.297h7.012V4.593h-7.012zm95.656-5.726c5.083 0 8.998-3.858 8.998-8.998 0-5.142-3.915-9-8.998-9-4.966 0-8.706 3.858-8.706 9 0 5.14 3.74 8.998 8.706 8.998m-.935-24.366c4.966 0 8.414 2.163 9.407 4.908V15.87h7.012v29.449h-7.012v-4.265c-.993 2.745-4.441 4.907-9.407 4.907-8.297 0-14.724-6.66-14.724-15.366s6.427-15.367 14.724-15.367m24.215 7.011h-3.798V15.87h3.798V4.593h7.012V15.87h6.368v6.369h-6.368v23.08h-7.012z" fill="#003B4B"></path></g></svg>
            <svg class="Login__logo--old" xmlns="http://www.w3.org/2000/svg" width="241.14" height="42.48" viewBox="0 0 241.14 42.48"><g data-name="Layer 2"><g data-name="BACKGROUND" fill="#36636F"><path d="M0 16.15h6.75V18H2v2.8h4.34v1.81H2v4.74H0zM12.32 19a4.28 4.28 0 1 1 0 8.55 4.28 4.28 0 1 1 0-8.55zm0 6.81a2.53 2.53 0 1 0-2.5-2.53 2.47 2.47 0 0 0 2.5 2.53zM18.36 19.24h1.91v1.2a2.49 2.49 0 0 1 2.4-1.36 5 5 0 0 1 .57.05V21a3.66 3.66 0 0 0-.8-.08 2 2 0 0 0-2.17 2.16v4.24h-1.91zM24.64 19.24h1.9v1.16a2.49 2.49 0 0 1 4.44.09 2.69 2.69 0 0 1 2.64-1.41c1.77 0 2.8 1.25 2.8 3.24v5H34.5v-4.73c0-1.09-.52-1.79-1.44-1.79a1.68 1.68 0 0 0-1.6 1.87v4.64h-1.91v-4.72c0-1.09-.51-1.79-1.44-1.79a1.67 1.67 0 0 0-1.57 1.87v4.64h-1.9zM38 23.28A4 4 0 0 1 42.25 19a3.9 3.9 0 0 1 4 4.07v.67h-6.32a2.21 2.21 0 0 0 2.44 2.11 2.77 2.77 0 0 0 2.17-.93l1.15 1.12a4.33 4.33 0 0 1-3.39 1.46 4 4 0 0 1-4.3-4.16zm6.26-.87a1.93 1.93 0 0 0-2-1.76A2.16 2.16 0 0 0 40 22.41zM47.84 19.24h1.91v1.2a2.5 2.5 0 0 1 2.4-1.36 5 5 0 0 1 .57.05V21a3.66 3.66 0 0 0-.8-.08 2 2 0 0 0-2.17 2.16v4.24h-1.91zM54.12 16.15H56v11.16h-1.88zM57.24 19.24h2l2.35 5.89L64 19.24h2l-4.79 11.18h-2l1.3-3zM120.87 42.48c-11.07 0-21.49-2.19-29.33-6.16S79.26 27 79.26 21.24s4.36-11.07 12.28-15.08S109.8 0 120.87 0s21.5 2.19 29.34 6.16 12.28 9.36 12.28 15.08-4.36 11.07-12.28 15.08-18.21 6.16-29.34 6.16zm0-41.81C98.3.67 79.93 9.89 79.93 21.24s18.37 20.57 40.94 20.57 40.95-9.23 40.95-20.57S143.45.67 120.87.67z"></path><path d="M99 15l-3.69 12.19h-2.5L89.13 15h3.05l1.7 7.08c.09.41.18.9.28 1.49 0-.28.13-.78.28-1.49L96.21 15zM109.86 27.19h-3l-.74-2.6h-3.67l-.78 2.6h-2.52l4-12.18h2.8zm-4.09-4.26l-1.08-4a8.18 8.18 0 0 1-.28-1.46c-.08.41-.19.9-.32 1.46l-1.13 4zM117.17 27.19h-6V15h2.87v10.26h3.1zM121.66 27.19h-2.87V15h2.87zM132.47 18.73a3.75 3.75 0 0 1-1 2.76 4.48 4.48 0 0 1-3.35 1.19 7.26 7.26 0 0 1-.8 0h-.39v4.58h-2.81V15.54a8.44 8.44 0 0 1 3.7-.71 5.08 5.08 0 0 1 3.57 1.17 3.59 3.59 0 0 1 1.08 2.73zm-2.74 0a2.65 2.65 0 0 0-.46-1.71 1.9 1.9 0 0 0-1.52-.54 2.23 2.23 0 0 0-.86.14V21h.39a2.48 2.48 0 0 0 1.88-.5 2.35 2.35 0 0 0 .57-1.79zM144 27.19h-3l-.74-2.6h-3.67l-.77 2.6h-2.57l4-12.18H140zm-4.09-4.26l-1.08-4a8.18 8.18 0 0 1-.28-1.46c-.08.41-.19.9-.32 1.46l-1.13 4zM152 16.94h-2.11v10.25H147V16.94h-2.13V15H152zM182.85 19.4a3 3 0 0 0-.76-1.31 2.59 2.59 0 0 0-1.82-.66 2.77 2.77 0 0 0-2.67 2zm-6.93 6.32a6.69 6.69 0 0 1-1.59-4.51 7 7 0 0 1 1.49-4.63 5.6 5.6 0 0 1 4.45-1.9 5.32 5.32 0 0 1 4.33 1.91 7.2 7.2 0 0 1 1.4 4.54v.77h-8.6a3.55 3.55 0 0 0 .8 1.89 2.75 2.75 0 0 0 2.14 1 3 3 0 0 0 1.76-.51 5 5 0 0 0 1.26-1.48l.21-.36 2.58 1.45-.21.37a6.3 6.3 0 0 1-5.62 3.32 5.75 5.75 0 0 1-4.39-1.86M194.94 27.2v-6.91a6.14 6.14 0 0 0-.18-1.75 1.29 1.29 0 0 0-.73-.86 2.74 2.74 0 0 0-1.14-.2 2.42 2.42 0 0 0-1.39.35 1.86 1.86 0 0 0-.67.87 8.23 8.23 0 0 0-.32 2.87v5.63h-3V15h3v.79a4.54 4.54 0 0 1 3-1.13 4 4 0 0 1 3.56 1.61A6.6 6.6 0 0 1 198 20v7.2zM198.04 15.02h3.41l2.96 6.46 2.99-6.46h3.41l-6.4 13.12-6.37-13.12zM214.38 23.6a3.36 3.36 0 0 0 4.86 0 3.53 3.53 0 0 0 0-4.94 3.38 3.38 0 0 0-4.86 0 3.55 3.55 0 0 0 0 4.94m2.43 4a6.45 6.45 0 1 1 0-12.9 6.45 6.45 0 1 1 0 12.9z"></path><path d="M233.15 15.02l-3.3 6.67-3.55-6.67h-3.52l5.41 9.82-2.8 5.18h3.45l7.72-15h-3.41zM240.27 10a1.43 1.43 0 1 1 0-.06zm-1.4-2.33a2.27 2.27 0 0 0-2.26 2.27 2.27 2.27 0 0 0 4.53 0 2.29 2.29 0 0 0-2.27-2.27"></path></g></g></svg>
          </div>

          <div v-if="$auth.error" class="Login__error">{{ $auth.error }}</div>
          <div class="FieldGroup">
            <label for="email" class="FieldGroup__label">E-mail address</label>
            <input id="email" type="email" class="FieldGroup__input" placeholder="user@domain.com" v-model="email" />
          </div>

          <div class="FieldGroup">
            <label for="password" class="FieldGroup__label">Password</label>
            <input id="password" type="password" class="FieldGroup__input" v-model="password" />
          </div>

          <button type="submit" :disabled="!$auth.canLogin" class="Button Button--tertiary">Log in</button>
          <!-- <a href="#" class="Login__link">Forgot password?</a> -->
        </form>

        <p class="Login__isSecured">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
            <defs><path id="a" d="M0 0h24v24H0V0z"></path></defs>
            <clipPath id="b"><use xlink:href="#a" overflow="visible"></use></clipPath>
            <path clip-path="url(#b)" d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"></path>
          </svg>
          This connection is secured
        </p>
      </div>
    </transition>
  </section>
</template>

<script>
import Loader from "tesseract-loader";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      email: "",
      password: ""
    };
  },

  methods: {
    submit() {
      this.$auth.login(this.email, this.password);
    }
  },

  components: { Loader }
};
</script>
<style lang="sass" scoped>
$dark: #36636F
$medium: #688A93
$light: #9BB1B7
$smoke: #F3F6F6

$global-radius: 2px

*
  box-sizing: border-box

svg
  max-width: 100%

.Login
  position: relative
  min-height: 100vh
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  font-size: 16px
  color: $dark
  background: $smoke
  overflow: auto
  &__container
    max-width: 400px
    margin: 10vh auto
    padding: 50px
    background: #fff
    box-shadow: 0px 0px 25px rgba($dark, 0.1)
    border-radius: $global-radius
    text-align: left
    transition: all .2s ease-in-out
  &__logo
    display: block
    text-align: center
    margin: 0 auto 3rem
    filter: color($dark)
    &--delegate
      max-width: 16rem
    &--old
      max-width: 15rem
  &__isSecured
    color: $light
    text-align: center
    svg
      vertical-align: middle
      fill: currentColor
  &__link
    display: block
    color: $medium
    text-align: center
  &__error
    margin: 0 0 1em
    color: tomato
    font-style: italic
  &__loading
    position: absolute
    top: 0
    left: 0
    right: 0
    margin: 20vh auto 1em
    text-align: center
    p
      color: $medium

.FieldGroup
  margin-bottom: 1.25rem
  &__label
    margin-bottom: 2px
    display: block
    font-weight: 500
  &__input
    display: block
    width: 100%
    font-size: 1em
    min-height: 2.625rem // 42px
    padding: 0.5em 0.75em
    background: #fff
    border: 1px solid $light
    box-sizing: border-box
    box-shadow: inset 0px 1px 2px rgba($dark, 0.15)
    border-radius: $global-radius
    ::placeholder
      color: $light

.Button
  width: 100%
  font-size: 1em
  min-height: 3.25em

.fade-enter-active, .fade-leave-active
  transition: all .2s ease-in-out

.fade-enter, .fade-leave-to
  opacity: 0
  .Login__container
    transform: translateY(-30%)
  &.Login__loading
    transform: scale(0.7)

.fade-leave-active,
.fade-enter-active
  &.Login__container
    position: absolute
    top: 0
    left: 0
    right: 0
    margin-left: auto
    margin-right: auto
</style>
